import store from "@src/reducers/store";
import { updateShowRenderOnlyForDevelopersStyle } from "@src/reducers/your-reducer";

export const toggleDevBorder = () => {
  const showRenderOnlyForDevelopersStyle =
    store.getState().yourSlice.showRenderOnlyForDevelopersStyle;

  store.dispatch(
    updateShowRenderOnlyForDevelopersStyle(!showRenderOnlyForDevelopersStyle),
  );
};
